import { features } from './N03-21_210101.json';

const optionMap = {};
// export function getOptions() {
//   features.forEach(item => {
//     const properties = item.properties;
//     const { N03_001, N03_002, N03_003, N03_004 } = properties;
//     if (!optionMap[N03_001]) {
//       optionMap[N03_001] = [];
//     }

//     const N03_004Obj = {
//       label: N03_004,
//       value: N03_004,
//     };

//     if (N03_003) {
//       let N03_003Obj = {
//         label: N03_003,
//         value: N03_003,
//         children: [N03_004Obj],
//       };

//       if (N03_002) {
//         let N03_002Obj = {
//           label: N03_002,
//           value: N03_002,
//           children: [N03_003Obj],
//         };

//         optionMap[N03_001].push(N03_002Obj);
//       } else {
//         optionMap[N03_001].push(N03_003Obj);
//       }
//     } else if (N03_002) {
//       let N03_002Obj = {
//         label: N03_002,
//         value: N03_002,
//         children: [N03_004Obj],
//       };

//       optionMap[N03_001].push(N03_002Obj);
//     } else {
//       optionMap[N03_001].push(N03_004Obj);
//     }
//   });
// }

export function getOptions() {
  features.forEach(item => {
    const properties = item.properties;
    const { N03_001, N03_002, N03_003, N03_004 } = properties;
    if (!optionMap[N03_001]) {
      optionMap[N03_001] = {};
    }

    if (N03_002) {
      optionMap[N03_001][N03_002] = {};

      if (N03_003) {
        optionMap[N03_001][N03_002][N03_003] = {};

        if (N03_004) {
          optionMap[N03_001][N03_002][N03_003][N03_004] = {};
        }
      } else if (N03_004) {
        optionMap[N03_001][N03_002][N03_004] = {};
      }
    } else if (N03_003) {
      optionMap[N03_001][N03_003] = {};

      if (N03_004) {
        optionMap[N03_001][N03_003][N03_004] = {};
      }
    } else if (N03_004) {
      optionMap[N03_001][N03_004] = {};
    }
  });

  console.log(optionMap, "optionMap", Object.values(optionMap))

  const options = getOptionsArr(optionMap);
  console.log(options, "options")

  // Object.keys(optionMap).map(item => {
  //   const value = {
  //     label: item,
  //     value: item
  //   };

  //   const content = optionMap(item);
  // })
  return options;
}

export function getFeatures() {
  return features.map(item => item.properties);
}

function getOptionsArr(obj) {
  const arr = Object.keys(obj).map(item => {
    const value = {
      label: item,
      value: item,
    };

    const content = obj[item];
    const children = getOptionsArr(content);

    if (children.length) {
      value.children = children;
    }

    return value;
  });

  return arr;
}
